import { DetailsContent } from "components/app_layout/DetailsLayout";
import { BuyerDetails } from "lib/types/models";
import BuyerLinkWithLogo, { BuyerLinkData } from "../../components/buyer_details/BuyerLinkWithLogo";

import css from "./BuyerRedirectMessage.module.scss";

export type Props = {
  buyer: Pick<BuyerDetails, "name">;
  resolvedBuyers: BuyerLinkData[];
};

function BuyerRedirectPage({ buyer, resolvedBuyers }: Props): JSX.Element {
  return (
    <DetailsContent className={css.container}>
      <h1>Uh-oh!</h1>
      <h2>You are trying to visit an archived buyer.</h2>
      <p>
        <strong>{buyer.name}</strong> has been split into the following:
      </p>
      <div className={css.resolvedBuyers}>
        {resolvedBuyers.map((resolvedBuyer) => (
          <BuyerLinkWithLogo buyer={resolvedBuyer} key={resolvedBuyer.guid} />
        ))}
      </div>
    </DetailsContent>
  );
}

export default BuyerRedirectPage;
